import Image from 'next/image';
import RejectQuotation from '@/assets/img/rejected-quotation.svg';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal, Typography } from '@mui/material';

interface IModalSuccessDefault {
  text: string;
  title: string;
  isOpen: boolean;
  handleClose: () => void;
}

const ModalSuccessDefault = ({
  isOpen,
  handleClose,
  text,
  title,
}: IModalSuccessDefault) => {
  return (
    <Modal
      open={isOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          textAlign: 'center',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 350,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          borderRadius: '4px',
        }}
      >
        <Box sx={{ position: 'absolute', right: 16, top: 16 }}>
          <IconButton
            size="small"
            color="inherit"
            onClick={handleClose}
            aria-label="button-close-modal"
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ mt: 3 }}>
          <Image
            src={RejectQuotation}
            width="202"
            height="144"
            alt="Imagem de senha criada com sucesso"
          />
        </Box>
        <Typography sx={{ mt: 2 }} variant="h6">
          {title}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          {text}
        </Typography>
      </Box>
    </Modal>
  );
};

export default ModalSuccessDefault;
